import { localstorageKeys } from "@const/store";
import StorageService from "../StorageService";

export const setAuthToken = (request, requestCache) => {
  const token = StorageService.get(localstorageKeys.session, {}).accessToken;
  if (!request.skipAuth && token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  request.headers["Accept-Language"] =
    localStorage.getItem("i18nextLng") ?? "en";
  if (request.method === "get") {
    const cache = requestCache.get(request);
    if (cache) {
      cache.abort(); // Abort the previous request
      return request;
    }
    // Create a new AbortController and store it in the cache
    const controller = new AbortController();
    request.signal = controller.signal; // Attach the signal to the request
    requestCache.set(request, controller); // Store the controller in cache
  }
  return request;
};
